<script setup lang="ts">
import { computed } from 'vue'
import UiAvatar from '@/components/shared/UiAvatar.vue'

import type { Player } from '@/api/contract'
import { getAvatarId } from '@/helpers/get-avatar-id'

const props = defineProps<{
  player: Player
  isYou?: boolean
  isHost?: boolean
}>()

const avatarId = computed(() => getAvatarId(props.player))
</script>

<template>
  <div class="players-menu-card">
    <div class="players-menu-card__info">
      <ui-avatar :id="avatarId" class="players-menu-card__avatar" />
      <div class="players-menu-card__details">
        <div class="players-menu-card__name">
          {{ player.name }}
          <div class="players-menu-card__id" v-if="isHost">{{ $t('label.Host') }}</div>
          <div class="players-menu-card__id" v-if="isYou">{{ $t('label.You') }}</div>
        </div>
        <div class="players-menu-card__extra"><slot name="extra"></slot></div>
      </div>
    </div>
    <slot />
  </div>
</template>

<style lang="scss">
.players-menu-card {
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  border-radius: 12px;
  border: 1px solid #2c2d3e;
  background-color: #1f212e;
  color: #86899e;

  &__info {
    display: flex;
    gap: 12px;
    align-self: stretch;
  }

  &__details {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__avatar {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
  }

  &__name {
    color: #fff;
    font-size: 14px;
    font-weight: 500;
  }

  &__id {
    display: inline-flex;
    padding: 2px 6px;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #86899e;
    margin-left: 5px;

    border-radius: 6px;
    background: #2c2d3e;
  }

  &__extra {
    font-size: 12px;
    display: inline-flex;
    align-items: center;
  }
}
</style>
